module.exports = __webpack_public_path__ + "dad9f52527f75cd65e61e2adec740376.pdf";